import { render, staticRenderFns } from "./operationhistory.vue?vue&type=template&id=2945d042&"
import script from "./operationhistory.vue?vue&type=script&lang=ts&"
export * from "./operationhistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports